<template functional>
	<div class="component c-footer">
		<element-ad :key="'ad_footer'" name="signingday-repeated-1" />
		<div class="row  padding-0 bp-1024:padding-x-12">
			<div
				class="c-footer__wrapper padding-0 bp-1024:padding-y-48 d-block bp-1024:d-flex flex-item-1"
			>
				<div class="c-footer__info flex-item-1">
					<ul class="reset-list d-block bp-1024:d-flex">
						<li>
							<a href="http://sidearmsports.com/terms-of-service/"
								>Terms of Service</a
							>
						</li>
						<li>
							<a
								href="http://www.sidearmsports.com/privacypolicy/"
								>Privacy Policy</a
							>
						</li>
					</ul>
					<div>video platform powered by CBS Sports Digital</div>
				</div>
				<div class="c-footer__logos d-flex align-items-center justify-content-center">
					<div class="c-footer__sidearm">
						<img
							v-if="!props.dark_mode"
							width="204px"
							src="http://s3.amazonaws.com/logos.sidearmsports.com/footer_logos/sidearm/sidearm_powered-by_horizontal_blue-orange.svg"
							alt="Sidearm Sports Logo"
						/>
						<img
							v-if="props.dark_mode"
							width="204px"
							src="http://s3.amazonaws.com/logos.sidearmsports.com/footer_logos/sidearm/sidearm_powered-by_horizontal_white-orange.svg"
							alt="Sidearm Sports Logo"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TheFooter',
	props: {
		dark_mode: {
			type: Boolean,
			default: false,
		}
	}
};
</script>

<style scoped lang="scss">
.c-footer {
	font-size: 16px;
	line-height: 24px;
	background: $main-color;
	color: $main-font-color;
	&__wrapper {
	}
	&__sidearm {
		padding: 0 0 0 24px;
	}
	&__learfield {
		padding: 0 24px;
		border-right: 1px solid $main-border-color;
	}
	&__info {
		ul {
			margin: 0 0 6px 0;
			li {
				padding: 0 12px;
				&:nth-child(1) {
					padding: 0 12px 0 0;
					border-right: 1px solid $main-border-color;
				}
				a {
					text-decoration: none;
					&:hover {
						text-decoration: underline;
					}
				}
			}
		}
	}
	@media screen and (max-width: 1024px) {
		&__info {
			ul {
				margin: 0;
				li {
					padding: 12px 24px !important;
					border-bottom: 1px solid $main-border-color;
				}
			}
			> div {
				padding: 12px 24px !important;
				border-bottom: 1px solid $main-border-color;
			}
		}
		&__logos {
			align-items: flex-start;
			> div {
				flex: 0 1 50%;
				padding: 24px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}
}
</style>
